document.documentElement.classList.remove('no-js');

/* -----------------------------------------------------------
   Scroll reveal
----------------------------------------------------------- */
(function initReveal() {
  var items = document.querySelectorAll('[data-reveal]');
  if (!items.length) return;
  if (!('IntersectionObserver' in window)) {
    items.forEach(function (el) { el.classList.add('is-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
  items.forEach(function (el) { observer.observe(el); });
})();

/* -----------------------------------------------------------
   Signature: icons that draw themselves in on scroll
----------------------------------------------------------- */
(function initIconDraw() {
  if (!document.body.classList.contains('animations-on')) return;
  var icons = document.querySelectorAll('[data-draw-icon]');
  if (!icons.length) return;

  icons.forEach(function (svg) {
    var path = svg.querySelector('path');
    if (!path || typeof path.getTotalLength !== 'function') return;
    var length = path.getTotalLength();
    path.style.strokeDasharray = length;
    path.style.strokeDashoffset = length;
  });

  function reveal(svg) {
    var path = svg.querySelector('path');
    if (path) path.style.strokeDashoffset = '0';
  }

  if (!('IntersectionObserver' in window)) {
    icons.forEach(reveal);
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        reveal(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.4 });
  icons.forEach(function (svg) { observer.observe(svg); });
})();

/* -----------------------------------------------------------
   Header: the announcement bar + nav are wrapped in a permanently
   fixed block (.site-header-fixed), so they stay visible at all
   times, no matter how far you scroll. This measures that block's
   real height and pushes the page content down so nothing hides
   underneath it.
----------------------------------------------------------- */
(function initHeader() {
  var header = document.querySelector('[data-header]');
  var fixedBlock = document.querySelector('[data-site-header-fixed]');
  if (!header || !fixedBlock) return;

  function setHeaderHeightVar() {
    document.documentElement.style.setProperty('--site-header-height', fixedBlock.offsetHeight + 'px');
  }
  setHeaderHeightVar();
  window.addEventListener('resize', setHeaderHeightVar);
  window.addEventListener('load', setHeaderHeightVar);
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(setHeaderHeightVar);
  }

  window.addEventListener('scroll', function () {
    header.classList.toggle('is-scrolled', window.scrollY > 40);
  }, { passive: true });
})();

/* -----------------------------------------------------------
   Drawers (cart + mobile menu)
----------------------------------------------------------- */
(function initDrawers() {
  function closeAll() {
    document.querySelectorAll('[data-drawer].is-open').forEach(function (d) {
      d.classList.remove('is-open');
    });
    document.body.style.overflow = '';
  }

  // Delegated on document (not bound per-element) because the cart drawer
  // gets swapped out wholesale (replaceWith) after every AJAX cart update —
  // listeners attached directly to its old close/overlay buttons would be
  // thrown away along with them, leaving the fresh drawer unclosable.
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-drawer-open]');
    if (openBtn) {
      var drawer = document.getElementById(openBtn.getAttribute('data-drawer-open'));
      if (drawer) {
        drawer.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      }
      return;
    }
    if (e.target.closest('[data-drawer-close]')) closeAll();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });
})();

/* -----------------------------------------------------------
   Header search panel
----------------------------------------------------------- */
(function initSearch() {
  var openBtn = document.querySelector('[data-search-open]');
  var closeBtn = document.querySelector('[data-search-close]');
  var panel = document.querySelector('[data-search-panel]');
  if (!panel) return;
  if (openBtn) openBtn.addEventListener('click', function () {
    panel.classList.add('is-open');
    var input = panel.querySelector('input[type="search"]');
    if (input) setTimeout(function () { input.focus(); }, 100);
  });
  if (closeBtn) closeBtn.addEventListener('click', function () { panel.classList.remove('is-open'); });
})();

/* -----------------------------------------------------------
   Newsletter popup
----------------------------------------------------------- */
(function initPopup() {
  var popup = document.getElementById('NewsletterPopup');
  if (!popup) return;
  var delay = parseInt(popup.getAttribute('data-popup-delay') || '4000', 10);
  var frequency = popup.getAttribute('data-popup-frequency') || 'day';
  var storageKey = 'ilus_newsletter_popup_seen';

  function hasBeenSeen() {
    if (frequency === 'always') return false;
    if (frequency === 'session') return sessionStorage.getItem(storageKey) === '1';
    var seenAt = localStorage.getItem(storageKey);
    if (!seenAt) return false;
    var oneDay = 24 * 60 * 60 * 1000;
    return Date.now() - parseInt(seenAt, 10) < oneDay;
  }

  function markSeen() {
    if (frequency === 'session') sessionStorage.setItem(storageKey, '1');
    else if (frequency === 'day') localStorage.setItem(storageKey, String(Date.now()));
  }

  function openPopup() {
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    markSeen();
  }

  function closePopup() {
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  popup.querySelectorAll('[data-popup-close]').forEach(function (el) {
    el.addEventListener('click', closePopup);
  });

  if (!hasBeenSeen()) {
    setTimeout(openPopup, delay);
  }
})();

/* -----------------------------------------------------------
   Marquee speed (data-marquee-speed on category marquee groups)
----------------------------------------------------------- */
(function initMarqueeSpeed() {
  document.querySelectorAll('[data-marquee]').forEach(function (marquee) {
    var speed = marquee.getAttribute('data-marquee-speed');
    if (!speed) return;
    marquee.querySelectorAll('.category-marquee__group').forEach(function (group) {
      group.style.animationDuration = speed + 's';
    });
  });
})();

/* -----------------------------------------------------------
   Generic horizontal carousels (products / testimonials)
----------------------------------------------------------- */
(function initCarousels() {
  document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('[data-carousel-track]');
    var prev = carousel.querySelector('[data-carousel-prev]');
    var next = carousel.querySelector('[data-carousel-next]');
    if (!track) return;

    function scrollAmount() {
      var slide = track.children[0];
      return slide ? slide.getBoundingClientRect().width + 24 : 300;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: scrollAmount(), behavior: 'smooth' }); });
  });
})();

/* -----------------------------------------------------------
   Anime carousel ("Para Girlies Otakus +").

   Plain drag carousel — every card the same size, no center-emphasis
   effect. Position is a single transform:translateX() on the track,
   driven entirely by our own JS (pointer drag + arrow clicks), bounded
   so it stops exactly flush with the first and last card — never
   showing empty space at either end.
----------------------------------------------------------- */
(function initCenterCarousels() {
  document.querySelectorAll('[data-center-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('[data-center-track]');
    if (!track) return;
    var items = Array.prototype.slice.call(track.querySelectorAll('[data-center-item]'));
    if (!items.length) return;

    var currentX = 0;

    function bounds() {
      var min = Math.min(0, carousel.clientWidth - track.scrollWidth);
      return { min: min, max: 0 };
    }

    function clamp(x) {
      var b = bounds();
      return Math.max(b.min, Math.min(b.max, x));
    }

    function setPosition(x, withTransition) {
      currentX = clamp(x);
      track.style.transition = withTransition ? 'transform .5s cubic-bezier(.22,.61,.36,1)' : 'none';
      track.style.transform = 'translateX(' + currentX.toFixed(2) + 'px)';
    }

    function stepSize() {
      if (items.length > 1) return items[1].offsetLeft - items[0].offsetLeft;
      return items[0] ? items[0].offsetWidth : 300;
    }

    // Pointer-based drag (mouse + touch + pen, unified) — the track has
    // no native scrolling, so this is the only way to move it besides
    // the arrow buttons.
    var drag = null;
    track.addEventListener('pointerdown', function (e) {
      drag = { startX: e.clientX, startPos: currentX, moved: false };
      setPosition(currentX, false);
      try { track.setPointerCapture(e.pointerId); } catch (err) {}
    });
    track.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var dx = e.clientX - drag.startX;
      if (Math.abs(dx) > 4) drag.moved = true;
      if (drag.moved) setPosition(drag.startPos + dx, false);
    });
    function endDrag() {
      if (!drag) return;
      drag = null;
      setPosition(currentX, true); // settle against the bounds with a smooth snap if it overshot
    }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);

    // Prevent the click that follows a real drag from also following the
    // card's link (native browsers already suppress this in most cases;
    // this is a belt-and-suspenders guard for the rest).
    items.forEach(function (item) {
      item.addEventListener('click', function (e) {
        if (drag && drag.moved) e.preventDefault();
      });
    });

    var prevBtn = carousel.querySelector('[data-center-prev]');
    var nextBtn = carousel.querySelector('[data-center-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { setPosition(currentX + stepSize(), true); });
    if (nextBtn) nextBtn.addEventListener('click', function () { setPosition(currentX - stepSize(), true); });

    // ResizeObserver keeps the position correctly clamped whenever the
    // carousel's size changes (window resize, editor sidebar, or simply
    // settling into its final layout width right after load).
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(function () { setPosition(currentX, false); });
      ro.observe(carousel);
    } else {
      window.addEventListener('resize', function () { setPosition(currentX, false); });
    }
  });
})();

/* -----------------------------------------------------------
   Hero slideshow
----------------------------------------------------------- */
(function initSlideshow() {
  document.querySelectorAll('[data-slideshow]').forEach(function (section) {
    var slides = section.querySelectorAll('[data-slide]');
    var dots = section.querySelectorAll('[data-slide-dot]');
    if (slides.length < 2) return;
    var index = 0;
    var autoplay = section.getAttribute('data-autoplay') === 'true';
    var interval = parseInt(section.getAttribute('data-interval') || '6000', 10);
    var timer;

    function show(i) {
      slides.forEach(function (s, idx) {
        var active = idx === i;
        s.classList.toggle('is-active', active);
        var video = s.querySelector('.hero-slide__video');
        if (video) {
          if (active) video.play().catch(function () {});
          else video.pause();
        }
      });
      dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === i); });
      index = i;
    }
    function nextSlide() { show((index + 1) % slides.length); }
    function prevSlide() { show((index - 1 + slides.length) % slides.length); }
    function restartAutoplay() {
      clearInterval(timer);
      if (autoplay) timer = setInterval(nextSlide, interval);
    }

    var nextBtn = section.querySelector('[data-slide-next]');
    var prevBtn = section.querySelector('[data-slide-prev]');
    if (nextBtn) nextBtn.addEventListener('click', function () { nextSlide(); restartAutoplay(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prevSlide(); restartAutoplay(); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { show(i); restartAutoplay(); });
    });

    restartAutoplay();
  });
})();

/* -----------------------------------------------------------
   Product gallery thumbnails
----------------------------------------------------------- */
(function initGallery() {
  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-slide]'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
    var prevBtn = gallery.querySelector('[data-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-gallery-next]');
    if (!slides.length) return;

    function goTo(index) {
      var i = ((index % slides.length) + slides.length) % slides.length;
      slides.forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-index') === String(i)); });
      thumbs.forEach(function (t) {
        var active = t.getAttribute('data-index') === String(i);
        t.classList.toggle('is-active', active);
        // Thumbnails scroll horizontally now (instead of wrapping into a
        // grid), so keep whichever one is active scrolled into view —
        // otherwise picking a color/photo via prev-next or a swatch can
        // leave the highlighted thumb off-screen with no visual cue.
        if (active) t.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      });
    }

    function currentIndex() {
      var active = slides.filter(function (s) { return s.classList.contains('is-active'); })[0];
      return active ? parseInt(active.getAttribute('data-index'), 10) : 0;
    }

    // When a color swatch is picked, initProductForm records the set of
    // media ids that belong to that color on window.__galleryGroupMediaIds.
    // Prev/next then stay within that color's photos and only spill over
    // into the other color's photos once they've all been seen — instead
    // of jumping straight to whichever photo happens to be next in the
    // product's overall (unsorted-by-color) media order.
    function stepWithinGroup(current, direction) {
      var groupIds = window.__galleryGroupMediaIds;
      if (!groupIds || !groupIds.length) return current + direction;
      var groupIndexes = [];
      slides.forEach(function (s, idx) {
        if (groupIds.indexOf(s.getAttribute('data-media-id')) !== -1) groupIndexes.push(idx);
      });
      // Only *some* variants get a specific photo connected to them in
      // Shopify (the rest of that color's shots are just unattached
      // product images) — with 1 or 0 matches there's nothing meaningful
      // to stay "within", so fall back to browsing the whole gallery
      // rather than getting stuck on the same slide.
      if (groupIndexes.length <= 1) return current + direction;
      var pos = groupIndexes.indexOf(current);
      if (pos === -1) return groupIndexes[0];
      var nextPos = ((pos + direction) % groupIndexes.length + groupIndexes.length) % groupIndexes.length;
      return groupIndexes[nextPos];
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { goTo(parseInt(thumb.getAttribute('data-index'), 10)); });
    });
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(stepWithinGroup(currentIndex(), -1)); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(stepWithinGroup(currentIndex(), 1)); });
  });
})();

/* -----------------------------------------------------------
   Quantity steppers (product form + cart)
----------------------------------------------------------- */
(function initQuantitySteppers() {
  document.addEventListener('click', function (e) {
    var incBtn = e.target.closest('[data-quantity-increase]');
    var decBtn = e.target.closest('[data-quantity-decrease]');
    if (!incBtn && !decBtn) return;
    var wrapper = (incBtn || decBtn).closest('.quantity-selector');
    if (!wrapper) return;
    var input = wrapper.querySelector('.quantity__input');
    if (!input) return;
    var value = parseInt(input.value || '1', 10);
    value = incBtn ? value + 1 : Math.max(1, value - 1);
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();

/* -----------------------------------------------------------
   Product form: variant swatches -> update hidden variant id, price, availability
----------------------------------------------------------- */
(function initProductForm() {
  var form = document.getElementById('ProductForm');
  if (!form) return;
  var jsonEl = document.querySelector('[data-product-json]');
  if (!jsonEl) return;

  var productData;
  try { productData = JSON.parse(jsonEl.textContent); } catch (e) { return; }

  // Self-contained reimplementation of Shopify's money formatter — the
  // theme never loads Shopify's own money.js, so window.Shopify.formatMoney
  // doesn't exist; relying on it silently no-ops and the price never
  // updates when a variant is picked.
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision == null ? 2 : precision;
    thousands = thousands == null ? ',' : thousands;
    decimal = decimal == null ? '.' : decimal;
    if (isNaN(number) || number == null) return 0;
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
    var cents = parts[1] ? decimal + parts[1] : '';
    return dollars + cents;
  }
  function formatMoney(cents) {
    var format = productData.money_format || '${{amount}}';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholderRegex);
    var kind = match ? match[1] : 'amount';
    var value;
    switch (kind) {
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return match ? format.replace(placeholderRegex, value) : value;
  }

  var selected = {};
  form.querySelectorAll('[data-option-value].is-selected').forEach(function (btn) {
    selected[btn.getAttribute('data-option-position')] = btn.getAttribute('data-value');
  });

  function findVariant() {
    return productData.variants.find(function (variant) {
      return variant.options.every(function (opt, idx) {
        return selected[String(idx + 1)] === opt;
      });
    });
  }

  function updateUI(variant) {
    var submitBtn = form.querySelector('[data-add-to-cart]');
    var textEl = form.querySelector('[data-add-to-cart-text]');
    var hiddenId = form.querySelector('[data-product-variant-id]');
    if (!variant) {
      if (submitBtn) submitBtn.setAttribute('disabled', 'disabled');
      if (textEl) textEl.textContent = textEl.getAttribute('data-label-unavailable') || textEl.textContent;
      return;
    }
    if (hiddenId) hiddenId.value = variant.id;

    if (variant.featured_media_id) {
      var gallery = document.querySelector('[data-product-gallery]');
      if (gallery) {
        var targetSlide = gallery.querySelector('[data-gallery-slide][data-media-id="' + variant.featured_media_id + '"]');
        if (targetSlide) {
          var targetIndex = targetSlide.getAttribute('data-index');
          gallery.querySelectorAll('[data-gallery-slide]').forEach(function (s) {
            s.classList.toggle('is-active', s.getAttribute('data-index') === targetIndex);
          });
          gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
            t.classList.toggle('is-active', t.getAttribute('data-index') === targetIndex);
          });
        }
      }
    }

    if (submitBtn) {
      if (variant.available) submitBtn.removeAttribute('disabled');
      else submitBtn.setAttribute('disabled', 'disabled');
    }
    if (textEl) {
      textEl.textContent = variant.available
        ? textEl.getAttribute('data-label-available') || textEl.textContent
        : textEl.getAttribute('data-label-soldout') || textEl.textContent;
    }

    var priceWrap = document.getElementById('ProductPrice');
    if (priceWrap) {
      var current = priceWrap.querySelector('.price__current');
      var compare = priceWrap.querySelector('.price__compare');
      var fromLabel = priceWrap.querySelector('.price__from');
      var onSale = variant.compare_at_price > variant.price;

      if (current) current.textContent = formatMoney(variant.price);
      if (fromLabel) fromLabel.remove();
      priceWrap.classList.toggle('price--sale', onSale);
      if (onSale) {
        if (compare) {
          compare.textContent = formatMoney(variant.compare_at_price);
        } else {
          compare = document.createElement('span');
          compare.className = 'price__compare';
          compare.textContent = formatMoney(variant.compare_at_price);
          priceWrap.insertBefore(compare, current);
        }
      } else if (compare) {
        compare.remove();
      }
    }
  }

  form.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-option-value]');
    if (!btn) return;
    var position = btn.getAttribute('data-option-position');
    var group = btn.closest('.product-form__swatches');
    group.querySelectorAll('[data-option-value]').forEach(function (b) { b.classList.remove('is-selected'); });
    btn.classList.add('is-selected');
    selected[position] = btn.getAttribute('data-value');

    // Shopify only lets a variant carry ONE connected photo, so grouping
    // "all of this color's photos" has to come from each image's alt
    // text instead (the standard workaround — include the option value,
    // e.g. "White", somewhere in the photo's alt text in Shopify admin).
    // Falls back to each variant's single connected photo if no alt text
    // mentions the value, so there's still *some* grouping either way.
    var posIndex = parseInt(position, 10) - 1;
    var value = selected[position];
    var valueLower = value.toLowerCase();
    var groupIds = (productData.media || [])
      .filter(function (m) { return m.alt && m.alt.toLowerCase().indexOf(valueLower) !== -1; })
      .map(function (m) { return m.id; })
      .map(String);
    if (!groupIds.length) {
      groupIds = productData.variants
        .filter(function (v) { return v.options[posIndex] === value; })
        .map(function (v) { return v.featured_media_id; })
        .filter(Boolean)
        .map(String);
    }
    window.__galleryGroupMediaIds = groupIds.length ? groupIds : null;

    updateUI(findVariant());
  });
})();

/* -----------------------------------------------------------
   AJAX cart (add / update / remove) with cart-drawer refresh
----------------------------------------------------------- */
(function initAjaxCart() {
  function refreshCartDrawer(forceOpen) {
    fetch('/?sections=cart-drawer,header')
      .then(function (res) { res.ok && res.json().then(function (data) {
        if (data['cart-drawer']) {
          var temp = document.createElement('div');
          temp.innerHTML = data['cart-drawer'];
          var newDrawer = temp.querySelector('#CartDrawer');
          var oldDrawer = document.getElementById('CartDrawer');
          if (newDrawer && oldDrawer) {
            if (forceOpen || oldDrawer.classList.contains('is-open')) newDrawer.classList.add('is-open');
            oldDrawer.replaceWith(newDrawer);
          }
        }
      }); })
      .catch(function () {});

    // The full /cart page (used when "Tipo de carrito" is set to "Página")
    // renders its own copy of the cart table — it isn't part of the
    // cart-drawer section above, so it needs its own refresh or it goes
    // stale the moment someone changes a quantity while standing on it.
    var cartPageSection = document.getElementById('shopify-section-main');
    if (cartPageSection && cartPageSection.querySelector('.cart-page')) {
      fetch('/cart?sections=main')
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (data) {
          if (data && data.main) {
            var temp = document.createElement('div');
            temp.innerHTML = data.main;
            var newSection = temp.querySelector('.cart-page');
            var oldSection = cartPageSection.querySelector('.cart-page');
            if (newSection && oldSection) oldSection.replaceWith(newSection);
          }
        })
        .catch(function () {});
    }

    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
    }).catch(function () {});
  }

  var productForm = document.getElementById('ProductForm');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var submitBtn = productForm.querySelector('[data-add-to-cart]');
      var existingError = productForm.querySelector('.product-form__error');
      if (existingError) existingError.remove();
      if (submitBtn) { submitBtn.setAttribute('disabled', 'disabled'); submitBtn.classList.add('is-loading'); }
      var formData = new FormData(productForm);

      fetch('/cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
        .then(function (res) {
          return res.json().then(function (data) { return { ok: res.ok, data: data }; });
        })
        .then(function (result) {
          if (!result.ok) {
            var errorEl = document.createElement('p');
            errorEl.className = 'product-form__error form-errors';
            errorEl.textContent = result.data.description || result.data.message || 'Something went wrong.';
            productForm.appendChild(errorEl);
            return;
          }
          refreshCartDrawer(true);
          if (document.getElementById('CartDrawer')) document.body.style.overflow = 'hidden';
        })
        .catch(function () { productForm.submit(); })
        .finally(function () {
          if (submitBtn) { submitBtn.removeAttribute('disabled'); submitBtn.classList.remove('is-loading'); }
        });
    });
  }

  document.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('[data-cart-remove]');
    var incBtn = e.target.closest('[data-cart-qty-increase]');
    var decBtn = e.target.closest('[data-cart-qty-decrease]');
    if (!removeBtn && !incBtn && !decBtn) return;

    var key = (removeBtn || incBtn || decBtn).getAttribute('data-key');
    var quantity = 0;

    if (removeBtn) {
      quantity = 0;
    } else {
      var row = document.querySelector('[data-cart-item-key="' + key + '"]');
      var qtyEl = row && row.querySelector('.quantity__value');
      var current = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
      quantity = incBtn ? current + 1 : Math.max(0, current - 1);
    }

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function () { refreshCartDrawer(); })
      .catch(function () { window.location.reload(); });
  });
})();

/* -----------------------------------------------------------
   Language switcher (native Shopify localization form)

   - Manual choice via the header <select> submits the form and
     remembers the choice (localStorage) so we never override it again.
   - First-visit auto-detect: if the visitor's browser language matches
     one of the store's PUBLISHED languages and differs from the
     current one, switch once automatically. This is a practical
     stand-in for IP-based geolocation (that level of "detect the
     visitor's country and redirect" requires enabling Shopify Markets
     and the auto-detect toggle in Settings > Languages — store admin
     config, not something theme code can turn on).
----------------------------------------------------------- */
(function initLocalization() {
  var STORAGE_KEY = 'girliedrops-locale-chosen';

  document.querySelectorAll('[data-localization-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      try { window.localStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
      select.form.submit();
    });
  });

  if (!window.__girlieLocales || !window.__girlieCurrentLocale) return;

  var alreadyChosen;
  try { alreadyChosen = window.localStorage.getItem(STORAGE_KEY); } catch (e) { alreadyChosen = '1'; }
  if (alreadyChosen) return;

  var browserLang = ((navigator.language || navigator.userLanguage || '').split('-')[0] || '').toLowerCase();
  if (!browserLang || browserLang === window.__girlieCurrentLocale) return;

  var match = window.__girlieLocales.filter(function (code) { return code.toLowerCase() === browserLang; })[0];
  if (!match) return;

  try { window.localStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
  var select = document.querySelector('[data-localization-select]');
  if (select) {
    select.value = match;
    select.form.submit();
  }
})();

/* -----------------------------------------------------------
   Account: address book (edit/add toggle + delete confirm)
----------------------------------------------------------- */
(function initAddressBook() {
  document.querySelectorAll('[data-address-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var card = btn.closest('.address-card');
      var edit = card && card.querySelector('[data-address-edit]');
      if (edit) edit.hidden = !edit.hidden;
    });
  });

  document.querySelectorAll('[data-address-delete-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var message = form.getAttribute('data-confirm') || 'Delete this address?';
      if (!window.confirm(message)) e.preventDefault();
    });
  });
})();

/* -----------------------------------------------------------
   Account: "forgot password" panel toggle on the login page
----------------------------------------------------------- */
(function initRecoverPassword() {
  var toggle = document.querySelector('[data-recover-toggle]');
  var panel = document.querySelector('[data-recover-panel]');
  if (!toggle || !panel) return;
  toggle.addEventListener('click', function (e) {
    e.preventDefault();
    panel.hidden = !panel.hidden;
    if (!panel.hidden) {
      var input = panel.querySelector('input');
      if (input) input.focus();
    }
  });
})();

/* -----------------------------------------------------------
   Header dropdown: keep aria-expanded in sync with the CSS-driven
   hover/focus reveal, so screen readers get an accurate state.
----------------------------------------------------------- */
(function initNavDropdowns() {
  document.querySelectorAll('.header__nav-item.has-dropdown').forEach(function (item) {
    var link = item.querySelector('.header__nav-link');
    if (!link) return;
    function open() { link.setAttribute('aria-expanded', 'true'); }
    function close() { link.setAttribute('aria-expanded', 'false'); }
    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', close);
    item.addEventListener('focusin', open);
    item.addEventListener('focusout', function (e) {
      if (!item.contains(e.relatedTarget)) close();
    });
  });
})();
